// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-form[data-v-3d43111a] {\n  margin-bottom: 20px;\n}\n.selectLabel .el-input__inner[data-v-3d43111a] {\n  height: 28px !important;\n  line-height: 28px !important;\n  border: none;\n  font-weight: bold;\n  text-align: left;\n  padding: 0 !important;\n}\n[data-v-3d43111a] .el-form-item {\n  margin-bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
